import { AddMedicationAdministeredConstants } from '../store/addMedicationAdministered.constants'

export const addMedicationAdministeredSchemas = [
  {
    inputKey: AddMedicationAdministeredConstants.SET_MEDICATION,
    isNumber: false,
    type: 'object',
    properties: {
      SET_NAME: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,100}$',
      },
    },
    additionalProperties: false,
    required: ['SET_NAME'],
    errorMessage: {
      properties: {
        SET_NAME: 'Must be alphanumeric with max length of 100',
      },
    },
  },
  {
    inputKey: AddMedicationAdministeredConstants.SET_DOSE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_DOSE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999999.999,
      },
    },
    additionalProperties: false,
    required: ['SET_DOSE'],
  },
  {
    inputKey: AddMedicationAdministeredConstants.SET_RATE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_RATE: {
        type: 'number',
      },
    },
    additionalProperties: false,
    required: ['SET_RATE'],
  },
  {
    inputKey: AddMedicationAdministeredConstants.SET_CONCENTRATION,
    isNumber: true,
    type: 'object',
    properties: {
      SET_CONCENTRATION: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,250}$',
      },
    },
    additionalProperties: false,
    required: ['SET_CONCENTRATION'],
    errorMessage: {
      properties: {
        SET_COMMENTS: 'Must be alphanumeric with max length of 250',
      },
    },
  },
  {
    inputKey: AddMedicationAdministeredConstants.SET_LOT_NUMBER,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LOT_NUMBER: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,}$',
      },
    },
    additionalProperties: false,
    required: ['SET_LOT_NUMBER'],
    errorMessage: {
      properties: {
        SET_LOT_NUMBER: 'Must be alphanumeric',
      },
    },
  },
  {
    inputKey: AddMedicationAdministeredConstants.SET_COMMENTS,
    isNumber: false,
    type: 'object',
    properties: {
      SET_COMMENTS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,1000}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COMMENTS'],
    errorMessage: {
      properties: {
        SET_COMMENTS: 'Must be alphanumeric with max length of 1000',
      },
    },
  },
  {
    inputKey: AddMedicationAdministeredConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: AddMedicationAdministeredConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
]

export const addMedicationAdministeredSecondsSchemas = [
  {
    inputKey: AddMedicationAdministeredConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
